/**
 * api/yea.api.js — Year End Accounting API calls
 */
import client from './client';

const base = (societyId) => `/societies/${societyId}`;

// Financial Years
export const getFYs          = (sid)              => client.get(`${base(sid)}/fy`);
export const getFY           = (sid, fyId)         => client.get(`${base(sid)}/fy/${fyId}`);
export const createFY        = (sid, data)         => client.post(`${base(sid)}/fy`, data);
export const getFYDashboard  = (sid, fyId)         => client.get(`${base(sid)}/fy/${fyId}/dashboard`);
export const requestFYEdit   = (sid, fyId, d)      => client.post(`${base(sid)}/fy/${fyId}/request-edit`, d);
export const requestFYDelete = (sid, fyId, d)      => client.post(`${base(sid)}/fy/${fyId}/request-delete`, d);
export const addBankToFY     = (sid, fyId, data)   => client.post(`${base(sid)}/fy/${fyId}/add-bank`, data);

// Transactions
export const getTransactions    = (sid, fyId, params)        => client.get(`${base(sid)}/fy/${fyId}/transactions`, { params });
export const createTransaction  = (sid, fyId, data)          => client.post(`${base(sid)}/fy/${fyId}/transactions/income-expense`, data);
export const createContra       = (sid, fyId, data)          => client.post(`${base(sid)}/fy/${fyId}/transactions/contra`, data);
export const updateTransaction  = (sid, fyId, txnId, data)   => client.put(`${base(sid)}/fy/${fyId}/transactions/${txnId}`, data);
export const deleteTransaction  = (sid, fyId, txnId)         => client.delete(`${base(sid)}/fy/${fyId}/transactions/${txnId}`);

// Reports
export const getReceiptPaymentReport = (sid, fyId)         => client.get(`${base(sid)}/fy/${fyId}/transactions/reports/receipt-payment`);
export const getCashReport           = (sid, fyId)         => client.get(`${base(sid)}/fy/${fyId}/transactions/reports/cash`);
export const getSummaryReport        = (sid, fyId)         => client.get(`${base(sid)}/fy/${fyId}/transactions/reports/summary`);
export const getBankReport           = (sid, fyId, bankId) => client.get(`${base(sid)}/fy/${fyId}/transactions/reports/bank/${bankId}`);

// Account Heads
export const getHeads   = (sid, type)    => client.get(`${base(sid)}/heads`, { params: { type } });
export const createHead = (sid, data)    => client.post(`${base(sid)}/heads`, data);
export const deleteHead = (sid, headId)  => client.delete(`${base(sid)}/heads/${headId}`);

// Deletion Requests
export const createDeletionRequest  = (data)       => client.post('/deletion-requests', data);
export const getMyDeletionRequests  = ()            => client.get('/deletion-requests/mine');
export const getAllDeletionRequests  = (status)     => client.get('/deletion-requests', { params: { status } });
export const resolveDeletionRequest = (id, data)   => client.put(`/deletion-requests/${id}/resolve`, data);
